import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import EventAdverse from '../../ClinicHistoryViewIPS/components/ClinicalStudio/EventAdverse';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import history from '../../../../history';

const ClinicalStudioEventAdverse = (props) => {

    const goBackFromHistory = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
            state: {
                date: props.location.state.data.fecha,
                pageIndex: props.location.state.pageIndex
            }
        });
    }


    return (

        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 style={{ marginBottom: 30 }}>Evento Adverso</h3>
                </Col>
                <div className='top_info_buttons_hc'>
                    <div>
                        <Tooltip
                            title="Regresar al Listado de Historias Clínicas"
                        >
                            <IconButton
                                aria-label="upload picture"
                                component="span"
                                className='tooltip-top'
                                onClick={() => {
                                    goBackFromHistory();
                                }}
                            >
                                <ArrowBackIcon style={{ color: '#153365' }} />
                            </IconButton>
                        </Tooltip>
                        <span style={{ marginLeft: '0.25em' }}>Regresar al Listado de Historias</span>
                    </div>
                </div>
            </Row>
            <Row>
                <EventAdverse id_historia={props.location.state.data.id_historia} data={props.location.state.data} pageIndex={props.location.state.pageIndex} />
            </Row>
        </Container>
    )
};

export default ClinicalStudioEventAdverse;